import { ContainerStatusEnum, ErrorResponse } from '@gtpl/shared-models/common-models';
import { DocumentsApprovalResponse, DocumentsUploadData, GetAllDocApprovalResponse } from '@gtpl/shared-models/logistics';
import { CommonResponse, PlantIdRequest } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { DocumentsApprovalAdapter } from './adapters/documents-approval.adapter';
import { UpdateDocumentUploadInfo } from './dto/document-approval-update.dto';
import { DocumentsUploadDto } from './dto/documents-upload.dto';
import { DocumentsApprovalRepository } from './repository/documents-approval.repository';
import { SoRepository } from './repository/so-repository';
import { SaleOrder } from './sale-order.entitiy';
import {ContainerRegisterService} from '@gtpl/shared-services/logistics'
import { SaleOrderIdRequest } from '@gtpl/shared-models/procurement-management';
import { DocumentApprovalUpdateRequest } from '@gtpl/shared-models/sale-management';
@Injectable()
export class DocumentsService {
    constructor(private docRepo:DocumentsApprovalRepository, private adapter:DocumentsApprovalAdapter, private soRepo:SoRepository, private containerRegisterService:ContainerRegisterService){}

    // async CreateDocumentsApproval(createDto:DocumentsApprovalDto[]){
    //     const manager = new GenericTransactionManager();
    //     try{
    //         await manager.startTransaction();
    //         let flag:boolean =true;
    //         for(const doc of createDto){

    //             const convertedDto = await this.adapter.convertDtoToEntity(doc);
    //             const savedDoc = await manager.getCustomRepository(DocumentsApprovalRepository).save(convertedDto);

    //             if(!savedDoc){
    //                 flag=false;
    //             }
    //         }

    //         if(flag){
    //             await manager.completeTransaction();
    //         }else{
    //             throw new ErrorResponse(9999, 'Something Went Wrong')
    //         }
            

    //     }catch(error){
    //         await manager.releaseTransaction();
    //         return error;
    //     }
    // }
    async approveDocument(docDto:DocumentsUploadDto):Promise<DocumentsApprovalResponse>{
        console.log('approveDocumentService' + docDto.documentsApprovalId);
        const manager = new GenericTransactionManager();
        try{
            if(docDto.documentsApprovalId >0){
                const docData = await this.docRepo.findOne({where:{documentsApprovalId:docDto.documentsApprovalId}});
                    if(docData){
                        // docDto.customsInvoiceUploaded&&docDto.commonInvoiceUploaded&&docDto.commercialPackingListUploaded&&docDto.commercialInvoiceUploaded&&docDto.plantPackingListUploaded&&docDto.plantInvoiceUploaded&&
                        // check all the documents uploaded status updated or not 
                        if(docDto.bLDraftUploaded&&docDto.oblUploaded&&docDto.sIMPUploaded&&docDto.certificateOfOriginUploaded&&docDto.declarationOfShrimpUploaded){
                            await manager.startTransaction();
                            const convertedEntity = await this.adapter.convertApproverDtoToEntity(docDto);
                            const savedDoc = await manager.getCustomRepository(DocumentsApprovalRepository).save(convertedEntity);
                
                            if(savedDoc){
                                await manager.completeTransaction();
                                return new DocumentsApprovalResponse(true, 1111, 'Document Approved Successfully')
                            }else{
                                throw new ErrorResponse(9999, 'Failed to update document status')
                            }

                        }else{
                            return new DocumentsApprovalResponse(false, 9999, 'Before Approval Please confirm all the documents uploaded')

                            // throw new ErrorResponse(9999, 'Before Approval Please confirm all the documents uploaded')
                        }
                        
                        
                    }else{
                        throw new ErrorResponse(9999, 'Something Went Wrong')
                    }
            }else{
                return new DocumentsApprovalResponse(false, 9999, 'Before Approval Please confirm all the documents uploaded')

                // throw new ErrorResponse(9999, 'Before Approval Please confirm all the documents uploaded')
            }
           

        }catch(error){
            await manager.releaseTransaction();
            return error
        }
    }

    async updateDocumentInfo(docDto:UpdateDocumentUploadInfo):Promise<DocumentsApprovalResponse>{
        const manager = new GenericTransactionManager();
        try{
            await manager.startTransaction();
            const convertedEntity = await this.adapter.convertDtoToEntity(docDto);
            const savedDoc = await manager.getCustomRepository(DocumentsApprovalRepository).save(convertedEntity);

            if(savedDoc){
                await manager.completeTransaction();
                return new DocumentsApprovalResponse(true, 1111, 'Updated Successfully')
            }else{
                throw new ErrorResponse(9999, 'Failed to update document status')
            }

        }catch(error){
            await manager.releaseTransaction();
            return error
        }
    }

    async getAllSoDocumentsInfo(plantIdRequest:PlantIdRequest):Promise<GetAllDocApprovalResponse>{
        try{
            const checkSoShipped = await this.containerRegisterService.getSoIdsByStatus({status:ContainerStatusEnum.SHIPPED});
            let ids = checkSoShipped.data;
            const soDocUploadInfoRes : SaleOrder[] = await this.soRepo.getDocInfo(plantIdRequest,ids);
            console.log(soDocUploadInfoRes);
            const soDocInfo: DocumentsUploadData[] = []
            if(soDocUploadInfoRes.length>0){
                // let containerStatusMap = new Map<number, ContainerStatusEnum>();
                for(const soDoc of soDocUploadInfoRes){
                //     console.log("************************************************");
                //     console.log(containerStatusMap.has(soDoc.saleOrderId));

                //     if (!(containerStatusMap.has(soDoc.saleOrderId))) {
                //         const checkSoShipped = await this.containerRegisterService.getContainerDeatils({saleOrderId:soDoc.saleOrderId});
                //         console.log(checkSoShipped)
                //         if(checkSoShipped.status){
                //             containerStatusMap.set(soDoc.saleOrderId, checkSoShipped.data.status);
                //         }
                //         else{
                //             containerStatusMap.set(soDoc.saleOrderId, null);
                //         }
                //         console.log(containerStatusMap)
                //     }
                //     let soShipmentStatus = containerStatusMap.get(soDoc.saleOrderId);
                //     console.log(soShipmentStatus)

                //     if(soShipmentStatus?soShipmentStatus === ContainerStatusEnum.SHIPPED:null){

                        if(soDoc.docUpInfo){
                            const soDocData: DocumentsUploadData ={
                                documentsApprovalId:soDoc.docUpInfo.documentsApprovalId,
                                saleOrderId:soDoc.saleOrderId,
                                saleOrderNumber:soDoc.SoInvDetailsInfo.poNumber,
                                customsInvoiceUploaded:soDoc.docUpInfo.customsInvoiceUploaded,
                                commonInvoiceUploaded:soDoc.docUpInfo.commonInvoiceUploaded,
                                commercialPackingListUploaded:soDoc.docUpInfo.commercialPackingListUploaded,
                                commercialInvoiceUploaded:soDoc.docUpInfo.commercialInvoiceUploaded,
                                plantPackingListUploaded:soDoc.docUpInfo.plantPackingListUploaded,
                                plantInvoiceUploaded:soDoc.docUpInfo.plantInvoiceUploaded,
                                shipmentInstructionsUploaded:soDoc.docUpInfo.shipmentInstructionsUploaded,
                                form13sUploaded:soDoc.docUpInfo.formsThirteenUploaded,
                                bLDraftUploaded:soDoc.docUpInfo.bLDraftUploaded,
                                freightInvoiceUploaded:soDoc.docUpInfo.freightInvoiceUploaded,
                                oblUploaded:soDoc.docUpInfo.oblUploaded,
                                iSFWorksheetUploaded:soDoc.docUpInfo.iSFWorksheetUploaded,
                                sIMPUploaded:soDoc.docUpInfo.sIMPUploaded,
                                certificateOfOriginUploaded:soDoc.docUpInfo.certificateOfOriginUploaded,
                                declarationOfShrimpUploaded:soDoc.docUpInfo.declarationOfShrimpUploaded,
                                approverOneStatusUploaded:soDoc.docUpInfo.approverOneStatus,
                                approverTwoStatusUploaded:soDoc.docUpInfo.approverTwoStatus,
                                approverOne:soDoc.docUpInfo.approverOne,
                                approverTwo:soDoc.docUpInfo.approverTwo
                            }
                            soDocInfo.push(soDocData);
                        }else{
                            const soDocData: DocumentsUploadData ={
                                documentsApprovalId:0,
                                saleOrderId:soDoc.saleOrderId,
                                saleOrderNumber:soDoc.SoInvDetailsInfo.poNumber,
                                customsInvoiceUploaded:false,
                                commonInvoiceUploaded:false,
                                commercialPackingListUploaded:false,
                                commercialInvoiceUploaded:false,
                                plantPackingListUploaded:false,
                                plantInvoiceUploaded:false,
                                shipmentInstructionsUploaded:false,
                                form13sUploaded:false,
                                bLDraftUploaded:false,
                                freightInvoiceUploaded:false,
                                oblUploaded:false,
                                iSFWorksheetUploaded:false,
                                sIMPUploaded:false,
                                certificateOfOriginUploaded:false,
                                declarationOfShrimpUploaded:false,
                            
                                approverOneStatusUploaded:false,
                                approverOne:'',
                                
                                approverTwoStatusUploaded:false,
                                approverTwo:''
                            }
                            soDocInfo.push(soDocData);
                        }
                    // }
                    // else{
                    //     console.log("UUUU")
                    // }
                }
                console.log(soDocInfo);
                if(soDocInfo.length){
                    return new GetAllDocApprovalResponse(true, 1111, 'Uploaded Data Found Successfully', soDocInfo)
                }else{
                    throw new ErrorResponse(9999, 'Something Went Wrong');
                }
                
            }else{
                throw new ErrorResponse(9999, 'No Data Found');
            }

        }catch(err){
            return err;
        }
    }
    async updateDocumentStatus(req: DocumentApprovalUpdateRequest): Promise<CommonResponse> {
        try{

            const getDocInfo = await this.docRepo.findOne({where:{saleOrderId:req.saleOrderId}});
            if(getDocInfo != undefined){
                let flag = 0;
                if(req.documentName === "Bill Of Lading"){
                    const updateStatus = await this.docRepo.update(
                        { saleOrderId: req.saleOrderId },
                        { bLDraftUploaded: true }
                      );
                      if(updateStatus.affected>0){
                          flag = 1;
                      }
                }
                else if(req.documentName === "obl"){
                    const updateStatus = await this.docRepo.update(
                        { saleOrderId: req.saleOrderId },
                        { oblUploaded: true }
                      );
                      if(updateStatus.affected>0){
                        flag = 1;
                    }
                }
                else if(req.documentName === "CO"){
                    const updateStatus = await this.docRepo.update(
                        { saleOrderId: req.saleOrderId },
                        { certificateOfOriginUploaded: true }
                      );
                      if(updateStatus.affected>0){
                        flag = 1;
                    }
                }
                else if(req.documentName === "SIMP"){
                    const updateStatus = await this.docRepo.update(
                        { saleOrderId: req.saleOrderId },
                        { sIMPUploaded: true }
                      );
                      if(updateStatus.affected>0){
                        flag = 1;
                    }
                }
                else if(req.documentName === "DS"){
                    const updateStatus = await this.docRepo.update(
                        { saleOrderId: req.saleOrderId },
                        { declarationOfShrimpUploaded: true }
                      );
                      if(updateStatus.affected>0){
                        flag = 1;
                    }
                }
                if(flag){
                    return new CommonResponse(true, 1001,"Document upload status updated successfully.",);
                }
                else{
                    return new CommonResponse(false, 1010,"Document upload status update failed.",);

                }
            }
        } catch (err) {
          throw err;
        }
    
      }
}
